/**
 * Author: Andrés Aguilar
 * Date: 26/09/2019
 * Modified: 27/09/2019
 * Version: 0.0.2
 */
import Vue from "vue";

// purchase/list_orders_simpe/3/
// purchase/list_orders_by_camp/${camp}/
export default (warehouse) =>
  Vue.$http
    .get(`purchase/list_orders_simple/${warehouse}/`)
    .then((response) =>
      response.data.sort((a, b) => (a.folio < b.folio ? 1 : -1))
    )
    .catch((error) => {
      const response = error.response;

      if (response && response.status !== 404) {
        throw error;
      }
    });



// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchPurchaseOrdersByWarehouse.js